// src/components/TermsOfService.js
import React from 'react';
//import '../../css/TermsOfService.css'; // Adjusted path to import TermsOfService.css
const TermsOfService = () => {
    return (
        <div className="p-6 max-w-3xl mx-auto">
            <h1 className="text-2xl font-bold text-center my-6">Terms and Conditions</h1>

            <section className="my-4">
                <h2 className="font-semibold text-lg">
                    Agreement between User and{' '}
                    <a
                        href="https://api.affordablecustomehr.com/psychology-ai-notes-generator"
                        className="text-blue-600 hover:underline"
                    >
                        https://api.affordablecustomehr.com/psychology-ai-notes-generator
                    </a>
                </h2>
                <p className="my-2">
                    Welcome to{' '}
                    <a
                        href="https://api.affordablecustomehr.com/psychology-ai-notes-generator"
                        className="text-blue-600 hover:underline"
                    >
                        https://api.affordablecustomehr.com/psychology-ai-notes-generator
                    </a>
                    . The site is comprised of various web pages operated by Juggernaut Systems Express. By using this site,
                    you accept all terms, conditions, and notices stated here.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Privacy</h2>
                <p className="my-2">
                    Your use of the site is subject to Juggernaut Systems Express's Privacy Policy. Please review our Privacy
                    Policy for information on our data collection practices.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Electronic Communications</h2>
                <p className="my-2">
                    By visiting the site or sending emails to Juggernaut Systems Express, you consent to receive electronic
                    communications. You agree that these communications satisfy any legal requirement for written communication.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Your Account</h2>
                <p className="my-2">
                    You are responsible for maintaining the confidentiality of your account and password. Juggernaut Systems
                    Express is not responsible for unauthorized access due to account theft or misappropriation.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Children Under Thirteen</h2>
                <p className="my-2">
                    Juggernaut Systems Express does not knowingly collect information from persons under thirteen. Persons under
                    18 may use the site only with a parent or guardian's permission.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Links to Third Party Sites/Third Party Services</h2>
                <p className="my-2">
                    The site may contain links to third-party websites. Juggernaut Systems Express is not responsible for the
                    content of these linked sites.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">No Unlawful or Prohibited Use/Intellectual Property</h2>
                <p className="my-2">
                    You are granted a non-exclusive, non-transferable, revocable license to access and use the site according to
                    these terms. Unauthorized use is prohibited.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Indemnification</h2>
                <p className="my-2">
                    You agree to indemnify Juggernaut Systems Express for any losses arising from your use of the site or
                    violation of these terms.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Arbitration</h2>
                <p className="my-2">
                    Disputes will be resolved by final, binding arbitration under the Federal Arbitration Act.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Class Action Waiver</h2>
                <p className="my-2">
                    All arbitration will be on an individual basis, and class actions are not permitted.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Liability Disclaimer</h2>
                <p className="my-2">
                    The site is provided "as is" without any warranty. Juggernaut Systems Express is not liable for any damages
                    arising from your use of the site.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Termination/Access Restriction</h2>
                <p className="my-2">
                    Juggernaut Systems Express reserves the right to terminate access to the site at any time.
                </p>
            </section>

            <section className="my-4">
                <h2 className="font-semibold text-lg">Contact Us</h2>
                <p className="my-2">Juggernaut Systems Express</p>
                <p className="my-2">921 Cranston Dr, Chesapeake, Virginia 23320</p>
                <p className="my-2">Email: sherwin @ affordablecustomehr.com</p>
                <p className="my-2">Phone: 757-328-2736</p>
                <p className="my-2">Effective as of November 07, 2024</p>
            </section>
        </div>
    );
};

export default TermsOfService;
